import { Component, ComponentInterface, JSX, getAssetPath, h } from '@stencil/core';

@Component({
  tag: 'error-boundary',
  shadow: true,
  assetsDirs: ['../../assets']
})
export class ErrorBoundary implements ComponentInterface {
  private title: string;
  private imagePath: string;
  private content: JSX.Element;

  public componentWillLoad(): void {
    this.setContentBasedOnErrorType();
  }

  private setContentBasedOnErrorType(): void {
    this.imagePath = '../assets/icon/agl_illus_dig_no_load.svg';
    this.title = "Sorry, something's gone wrong.";
    this.content = (
      <span slot="content-line-1">
        We're having some issues accessing the right data. Please try reloading the page or&nbsp;
        <agl-ds-link href="/help-support/contact-us" sr-context="contact us">
          contact us
        </agl-ds-link>
        &nbsp;for help.
      </span>
    );
  }

  public render(): JSX.Element {
    return (
      <agl-ds-status-container class="error-container">
        <agl-ds-illustration-text-simple illustration-path={getAssetPath(this.imagePath)} size="md">
          <span slot="title">
            <agl-ds-spacer orientation="vertical" size="space04" />
            <agl-ds-h1 styled-as="title4">{this.title}</agl-ds-h1>
          </span>
          {this.content}
        </agl-ds-illustration-text-simple>
      </agl-ds-status-container>
    );
  }
}
